import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import React from 'react';
import StatusChip from '../../../../../Shared/StatusChip';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { DeviceHistoryItem } from '../../../../../../store/devices/deviceTypes';
import {
  formatEventTime,
  parseDateToLocal,
} from '../../../../../../shared/utils';
import {
  customError,
  dimGrey,
  errorBg,
  lightBlack,
} from '../../../../../../mainTheme';

interface HistoryDetailsProps {
  rowData: DeviceHistoryItem | null;
}

const DetailLabel = styled(Typography)({
  color: lightBlack,
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.2px',
});

const DetailValue = styled(Typography)({
  color: dimGrey,
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.2px',
});

export const HubHistoryDetails: React.FC<HistoryDetailsProps> = ({
  rowData,
}) => {
  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ flex: 1 }}>
          <DetailLabel>Issue ID</DetailLabel>
          <DetailValue>{rowData?.issue_id}</DetailValue>
        </Box>
        <Box sx={{ flex: 1 }}>
          <DetailLabel>Hub event</DetailLabel>
          <StatusChip
            icon={faExclamationTriangle}
            iconColor={customError}
            labelText={rowData?.title || ''}
            conditionalValue={true}
            backgroundColor={errorBg}
          />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ flex: 1 }}>
          <DetailLabel>Event time</DetailLabel>

          <DetailValue>{formatEventTime(rowData?.event_time)}</DetailValue>
        </Box>
        <Box sx={{ flex: 1 }}>
          <DetailLabel>Resolved time</DetailLabel>
          <DetailValue>
            {rowData?.resolved_time
              ? parseDateToLocal(rowData?.resolved_time, 'yyyy-MM-dd HH:mm:ss')
              : 'N/A'}
          </DetailValue>
        </Box>
      </Box>
    </Box>
  );
};
